import { defineCustomElement } from './defineCustomElementWithStyles'
import OverLay from './components/OverLay'
import ProductAvailability from './components/ProductAvailability'
import ProductAvailabilityList from './components/ProductAvailabilityList'
import FindStockist from './components/FindStockist'

const OverLayElement = defineCustomElement(OverLay)
const ProductAvailabilityElement = defineCustomElement(ProductAvailability)
const ProductAvailabilityListElement = defineCustomElement(ProductAvailabilityList)
const FindStockistElement = defineCustomElement(FindStockist)

customElements.define('pp-overlay', OverLayElement)
customElements.define('product-availability', ProductAvailabilityElement)
customElements.define('product-availability-list', ProductAvailabilityListElement)
customElements.define('pp-find-stockist', FindStockistElement)

// createApp(App).mount('#root')
